<template>
  <!-- Appliances registered -->
  <div id="registerAppliance" v-if="hasAppliances">
      <patternlib-icon icon-name="HOME" size="64px"></patternlib-icon>
      <p style="margin: 0px var(--spacing-6); text-align: center;">{{ $t("registerApplianceBanner.text") }}</p>
      <patternlib-button 
        :label="$t('registerApplianceBanner.button')"
        type="secondary"
        @click="() => {this.$router.push('/registerAppliance')}"
      ></patternlib-button>
  </div>

  <!-- No appliances registred -->
  <div id="registerAppliance" v-else>
    <patternlib-icon icon-name="HOME" size="64px"></patternlib-icon>
      <p style="margin: 0px var(--spacing-6); text-align: center;">{{ $t("registerApplianceBanner.textNoAppliances") }}</p>
      <patternlib-button 
        :label="$t('registerApplianceBanner.button')"
        type="secondary"
        @click="() => {this.$router.push('/registerAppliance')}"
      ></patternlib-button>
  </div>
</template>

<script>
export default {
  props: {
    hasAppliances: Boolean
  }
}
</script>

<style lang="scss" scoped>

#registerAppliance {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-5);
  height: 262px;
  width: 100%;

  border-style: dashed;
  border-width: 1px;
  border-color: var(--color-black);
  background-color: var(--color-steel-100);

  margin: var(--spacing-6) 0px;
}

</style>